export default __webpack_public_path__ + "static/documentary_fallback-8335b2ee7573c3781f02dc0181424dfb.webp";